import { alignment } from './alignment';
import { buttonVariant } from './buttonVariant';

/**
 * The text transform options for the button.
 */
export enum ButtonTextTransform {
  None = 'none',
  Uppercase = 'uppercase',
  Lowercase = 'lowercase'
}

const buttonStyling = {
  name: 'styling',
  friendlyName: 'Button Styling',
  type: 'object',
  subFields: [
    buttonVariant,
    alignment,
    {
      name: 'zIndex',
      friendlyName: 'Z-Index',
      type: 'number',
      defaultValue: 1
    },
    {
      name: 'margin',
      type: 'text',
      friendlyName: 'Margin',
      helperText: 'The link/button outer margins. Example: 10px or 10px 0 0 0.'
    },
    {
      name: 'padding',
      type: 'text',
      friendlyName: 'Padding',
      helperText: 'The link/button outer padding. Example: 10px or 10px 0 0 0.'
    },
    {
      name: 'height',
      type: 'text',
      friendlyName: 'Height',
      helperText: 'The link/button height. Example: 32px.'
    },
    {
      name: 'fontSize',
      type: 'text',
      friendlyName: 'Font Size',
      helperText: 'The link/button font size. Example: 16px.'
    },
    {
      name: 'textTransform',
      type: 'text',
      friendlyName: 'Text Transform',
      defaultValue: ButtonTextTransform.None,
      enum: Object.values(ButtonTextTransform).map((value) => {
        return { label: value.toUpperCase(), value };
      }),
      helperText: 'The link/button text transform style. Default is none.'
    },
    {
      name: 'width',
      type: 'text',
      friendlyName: 'Width',
      helperText:
        'The link/button width by percent or pixels. Example: 50% or 100px.'
    },
    {
      name: 'maxWidth',
      type: 'text',
      friendlyName: 'Max Width',
      defaultValue: 'unset',
      helperText:
        'The link/button max width by percent or pixels. Example: 50% or 100px.'
    },
    {
      name: 'minWidth',
      type: 'text',
      friendlyName: 'Min Width',
      defaultValue: 'unset',
      helperText:
        'The link/button min width by percent or pixels. Example: 50% or 100px.'
    }
  ]
};

export default buttonStyling;
